export function formatCounterReference(value, detail) {
  if (value == null || value === '') return '—'

  const normalizedDetail = typeof detail === 'string' ? detail.trim() : detail
  return normalizedDetail == null || normalizedDetail === ''
    ? String(value)
    : `${value} (${normalizedDetail})`
}
